import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const CogIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <path
                        fill="currentColor"
                        d="M13.8,21.7h-3.6V19c-0.5-0.1-1.1-0.3-1.6-0.5l-1.9,1.9l-3.1-3.1l1.9-1.9c-0.2-0.5-0.4-1-0.5-1.6H2.3v-3.6H5
			c0.1-0.5,0.3-1.1,0.5-1.6L3.6,6.7l3.1-3.1l1.9,1.9c0.5-0.2,1-0.4,1.6-0.5V2.3h3.6V5c0.5,0.1,1.1,0.3,1.6,0.5l1.9-1.9l3.1,3.1
            l-1.9,1.9c0.2,0.5,0.4,1,0.5,1.6h2.7v3.6H19c-0.1,0.5-0.3,1.1-0.5,1.6l1.9,1.9l-3.1,3.1l-1.9-1.9c-0.5,0.2-1,0.4-1.6,0.5V21.7z
            M11.4,20.5h1.2V18l0.5-0.1c0.4-0.1,1.6-0.4,2.1-0.7l0.4-0.2l1.7,1.7l1.4-1.4L17,15.6l0.2-0.4c0.3-0.6,0.6-1.7,0.7-2.1l0.1-0.5
			h2.4v-1.2H18L17.9,11c-0.1-0.4-0.4-1.6-0.7-2.1L17,8.4l1.7-1.7l-1.4-1.4L15.6,7l-0.4-0.2c-0.6-0.3-1.7-0.6-2.1-0.7L12.6,6V3.5
			h-1.2V6L11,6.1c-0.4,0.1-1.6,0.4-2.1,0.7L8.4,7L6.7,5.3L5.3,6.7L7,8.4L6.8,8.8C6.5,9.4,6.2,10.5,6.1,11L6,11.4H3.5v1.2H6L6.1,13
			c0.1,0.4,0.4,1.6,0.7,2.1L7,15.6l-1.7,1.7l1.4,1.4L8.4,17l0.4,0.2c0.6,0.3,1.7,0.6,2.1,0.7l0.5,0.1V20.5z"
                    />
                </g>
                <g>
                    <path
                        fill="currentColor"
                        d="M12,16.1c-2.3,0-4.1-1.9-4.1-4.1S9.7,7.9,12,7.9c2.3,0,4.1,1.9,4.1,4.1S14.3,16.1,12,16.1z M12,9.1
			c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S13.6,9.1,12,9.1z"
                    />
                </g>
            </g>{" "}
        </SvgIcon>
    );
};
